import { equals } from 'ramda';
import { useMemo, useEffect } from 'react';
import { useUrlParams } from '../../hooks/useUrlParams';
import { transformLegacyPLPQueryParams } from './transformLegacyPLPQueryParams';

export const useRedirectLegacyPLPQueryParams = () => {
  const { params, setParams } = useUrlParams();
  const transformedParams = useMemo(() => transformLegacyPLPQueryParams(params), [params]);
  const shouldRedirect = useMemo(() => !equals(params, transformedParams), [
    params,
    transformedParams
  ]);

  useEffect(() => {
    shouldRedirect && setParams(transformedParams);
  }, [shouldRedirect, setParams, transformedParams]);
};
